import { Pipe, PipeTransform, inject } from '@angular/core';
import { ImageProcessorConfig } from '../models';

@Pipe({
  name: 'resize',
  standalone: true,
})
export class ResizePipe implements PipeTransform {
  private config = inject(ImageProcessorConfig);


  transform(
    imageUrl: string,
    width?: number,
    height?: number,
    anchor?:
      | 'topleft'
      | 'topcenter'
      | 'topright'
      | 'middleleft'
      | 'middlecenter'
      | 'middleright'
      | 'bottomleft'
      | 'bottomcenter'
      | 'bottomright',
    mode?: 'crop' | 'stretch' | 'pad' | 'max',
    format?: 'jpg' | 'png' | 'bmp' | 'gif' | 'webp',
    scale?: 'both' | 'down' | 'canvas',
    other?: string
  ): any {
    if (!imageUrl) {
      return imageUrl;
    }

    let url = imageUrl;
    // if url is not encoded, do it first
    if (decodeURI(imageUrl) === imageUrl) {
      url = encodeURI(imageUrl);
    }
    let val = `${url}`;
    if (width) {
      val = `${val}${this.separator(val)}${this.config.options.width}=${width}`;
    }
    if (height) {
      val = `${val}${this.separator(val)}${this.config.options.height}=${height}`;
    }
    if (anchor) {
      val = `${val}${this.separator(val)}${this.config.options.anchor}=${this.config.parseAnchor(anchor)}`;
    }
    if (mode) {
      val = `${val}${this.separator(val)}${this.config.options.mode}=${mode}`;
    }
    if (format) {
      val = `${val}${this.separator(val)}${this.config.options.format}=${format}`;
    }
    if (scale) {
      val = `${val}${this.separator(val)}${this.config.options.scale}=${scale}`;
    }
    if (other) {
      val = `${val}${this.separator(val)}${other}`;
    }

    return val;
  }

  private separator(url: string) {
    return url.indexOf('?') >= 0 ? '&' : '?';
  }
}
